import { getFormattedValue } from '../../../../Utilities';
export var getFormattedValueBasedOnType = function (value, currencyCode, locale) {
    var isNumber = typeof value === 'number';
    var location = locale || 'en-US';
    var formattedValue = '--';
    if (isNumber) {
        if (currencyCode) {
            formattedValue = getFormattedValue(value, true, currencyCode, undefined, location);
        }
        else {
            formattedValue = getFormattedValue(value, false, undefined, undefined, location);
        }
    }
    return formattedValue;
};
//# sourceMappingURL=DataGridColumnNumber.utilities.js.map